import { useParams } from 'react-router-dom';

import { logError } from 'lib/sentry/logError';
import { MenuItem } from 'shared';
import { updateArrayById } from 'shared_DEPRECATED/utils';

import { ChallengeTimelineItemType } from 'features/challenge/ChallengeTimelineItem';
import { useAddCustomChallenge } from 'features/challenge/hooks/useAddCustomChallenge';
import { useGoalQueryActions } from 'features/goal/hooks';
import { IGoal } from 'features/goal/types';
import { updateChallengeWithLinkedGoal } from 'features/goal/utils';
import { useLastSprint } from 'features/sprint/hooks/useLastSprint';

export const GoalBreakdownMenuAddChallengeButton = () => {
  const { goalId } = useParams();

  const sprint = useLastSprint();

  const {
    cancelGoalQueries,
    getGoalQuery,
    updateGoalQueryData,
    invalidateGoalQuery,
  } = useGoalQueryActions();

  const openAddChallengeModal =
    useAddCustomChallenge<ChallengeTimelineItemType>({
      //@ts-ignore
      sprint,
      options: {
        onMutate: async ({ challenges }) => {
          const previousValue = getGoalQuery();

          cancelGoalQueries();

          updateGoalQueryData((oldData: IGoal) => {
            oldData.challenges = [
              //because the useAddCustomChallenge hook can receive a single challenge or an array of challenges
              ...(Array.isArray(challenges)
                ? challenges.map((challenge) =>
                    updateChallengeWithLinkedGoal(challenge, oldData)
                  )
                : [updateChallengeWithLinkedGoal(challenges, oldData)]),
              ...oldData.challenges,
            ];
          });

          return { challenges: previousValue?.challenges ?? [] };
        },
        onSuccess: async ({ challenges }) => {
          updateGoalQueryData((oldData: IGoal) => {
            oldData.challenges = updateArrayById({
              array: oldData.challenges,
              updatedItem: challenges[0],
              idProperty: 'challengeId',
            });
          });
        },
        onError: async (
          error,
          __,
          context: { challenges: ChallengeTimelineItemType[] } | undefined
        ) => {
          if (!context?.challenges) {
            return;
          }

          updateGoalQueryData((oldData: IGoal) => {
            oldData.challenges = context.challenges;
          });

          logError(error);
        },
        onSettled: async () => {
          invalidateGoalQuery();
        },
      },
      parameters: { addToGoalId: goalId },
    });

  return <MenuItem onClick={openAddChallengeModal}>Challenge</MenuItem>;
};
